import { render, staticRenderFns } from "./BuySectionUsps.vue?vue&type=template&id=6d206807&scoped=true&"
import script from "./BuySectionUsps.vue?vue&type=script&lang=ts&"
export * from "./BuySectionUsps.vue?vue&type=script&lang=ts&"
import style0 from "./BuySectionUsps.vue?vue&type=style&index=0&id=6d206807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d206807",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsCheckmark16px: require('/var/www/packages/theme/components/icons/checkmark/Checkmark16px.vue').default,MoleculesUspsIconUsp: require('/var/www/packages/theme/components/molecules/Usps/IconUsp.vue').default,MoleculesBuySectionUspDrawer: require('/var/www/packages/theme/components/molecules/BuySectionUspDrawer.vue').default})
